import React from "react"

import { PageHelmetElement } from "@front-shared/elements/pageHelmet.element.tsx"
import { PrimaryText } from "@front-shared/elements/primaryText.element.tsx"
import { useScrollFix } from "@front-shared/hooks/scrollFix.hook.ts"

import { GENERAL_CONFIG } from "../../config/general.config"
import { SupportContentComponent } from "./supportContent.component"

export const SupportComponent: React.FunctionComponent = () => {
    useScrollFix()

    return (
        <div className="pb-32 relative">
            <PageHelmetElement
                title="Support"
                defaultPageTitle={GENERAL_CONFIG.defaultPageTitle}
            />

            <PrimaryText typography="h1">Support</PrimaryText>

            <PrimaryText className="mt-[8px]" typography="text">
                Looking to get the most out of Nirvana? We’re here to help.
            </PrimaryText>

            <SupportContentComponent className="mt-[32px]" />
        </div>
    )
}
